export default __webpack_public_path__ + "static/article-ways-to-instantly-boost-your-savings-d27ce0aa72356066a30d37d8f22cfe32.jpg";